import { SafeHtmlPipe } from './Pipe/safe.pipe';
import { FilterTabRegionPipe } from './Pipe/filterTabRegion.pipe';
import { FilterPipeRegionSearch } from './Pipe/filterRegionPort.pipe';
import { FilterAnneePipe } from './Publications/newsletter/newsletter.pipe';
import { FilterAlphabetPipe } from './acces rapide/lexique/lexique.pipe';
import { PortDetailComponent } from './Services/port-maroc/port-detail/port-detail.component';
import { PortMarocComponent } from './Services/port-maroc/port-maroc.component';
import { FilterTabSearch } from './Pipe/filtertab.pipe';
import { FilterPipeSearch } from './Pipe/search.pipe';
import { FilterPipe } from './Pipe/filter.pipe';
import { HomeService } from './Service/home.service';
import { LoaderInterceptor } from './Service/loader.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Pipe } from '@angular/core';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppRoutingModule, LowerCaseUrlSerializer } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HighchartsChartModule } from 'highcharts-angular';
import { StatiquePageComponent } from './statique-page/statique-page.component';
import { SvgBgPotnetComponent } from './svg-bg-portnet/svg-bg-portnet.component';
import { ANPEnChiffresComponent } from './Agence/anpen-chiffres/anpen-chiffres.component';
import { ChantiersInfrastructuresComponent } from './Grands Chantiers/chantiers-infrastructures/chantiers-infrastructures.component';
import { HistoriqueComponent } from './Agence/historique/historique.component';
import { OrganisationComponent } from './Agence/organisation/organisation.component';
import { StatistiquesComponent } from './Services/statistiques/statistiques.component';
import { CommuniquesPresseComponent } from './Publications/communiques-presse/communiques-presse.component';
import { PortComponent } from './Grands Chantiers/port/port.component';
import { UrlSerializer } from '@angular/router';
import { RapportsAnnuelsComponent } from './Agence/rapports-annuels/rapports-annuels.component';
import { OrgchartModule } from '@dabeng/ng-orgchart';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MvmNaviresComponent, MvmNaviresFilterPipe } from './Services/mvm-navires/mvm-navires.component';
import { PortcontentComponent } from './Services/port-maroc/port-detail/portcontent/portcontent.component';
import { SmartGateComponent } from './Services/smart-gate/smart-gate.component';
import { SecuritePortuaireComponent } from './Grands Chantiers/securite-portuaire/securite-portuaire.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import { PortnetComponent } from './Grands Chantiers/portnet/portnet.component';
import { PortnetServicesComponent } from './Services/portnet-services/portnet-services.component';
import { TarifsPublicsPlafondsComponent } from './Espace Professionnel/tarifs-publics-plafonds/tarifs-publics-plafonds.component';
import { IFPComponent } from './Formation Portuaire/ifp/ifp.component';
import { OffreDeFormationComponent } from './Formation Portuaire/offre-de-formation/offre-de-formation.component';
import { SimulateurComponent } from './Formation Portuaire/simulateur/simulateur.component';
import { ActualitesComponent } from './Publications/actualites/actualites.component'
import { AgenceSectionComponent } from './Agence/agence-section/agence-section.component';
import { AgencePageComponent } from './Agence/agence-section/agence-page/agence-page.component';
import { StatiqueMenuComponent } from './statique-menu/statique-menu.component';
import { AppelsOffresComponent, OffresFilterPipe } from './Publications/appels-offres/appels-offres.component'
import { PhotothequeComponent } from './Publications/phototheque/phototheque.component';
import { VideothequeComponent } from './Publications/videotheque/videotheque.component';
import { EmploiFilterPipe, OffresEmploisComponent } from './Publications/offres-emplois/offres-emplois.component';
import { Home2Component } from './home2/home2.component';
import { ContactComponent } from './acces rapide/contact/contact.component';
import { LexiqueComponent } from './acces rapide/lexique/lexique.component';
import { PlanSiteComponent } from './acces rapide/plan-site/plan-site.component';
import { NewsletterComponent } from './Publications/newsletter/newsletter.component';
import { PostulerComponent } from './Publications/postuler/postuler.component'
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Page404Component } from './page404/page404.component';
import { RechercheComponent } from './recherche/recherche.component';
import { ArchiveComponent } from './Publications/archive/archive.component'
import { GestionAccessComponent } from './Services/gestion-access/gestion-access.component';
import { SearchConfigComponent } from './search-config/search-config.component';
import { CentreMediaComponent } from './Publications/centre-media/centre-media.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ConsignationPortsComponent } from './Services/consignation-ports/consignation-ports.component';
import { StatistiquesNationalComponent } from './Services/statistiques-national/statistiques-national.component';
import { MvmNaviresAutoriseeComponent } from './Services/mvm-navires-autorisee/mvm-navires-autorisee.component'
import {MatSortModule} from '@angular/material/sort';
import { AppelConcurrenceComponent } from './Services/appel-concurrence/appel-concurrence.component';
import { ProgrammePrevComponent } from './Services/programme-prev/programme-prev.component';
import { AppelConsurrence2Component } from './Services/appel-consurrence2/appel-consurrence2.component';
import { SocietesautoriseesComponent } from './Services/societesautorisees/societesautorisees.component';
import { AppelManifestationComponent } from './Services/appel-manifestation/appel-manifestation.component';
import { DeposerCandidatureComponent } from './Publications/deposer-candidature/deposer-candidature.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FilterPipeSearch,
    MvmNaviresFilterPipe,
    OffresFilterPipe,
    FilterPipeRegionSearch,
    FooterComponent,
    HomeComponent,
    StatiquePageComponent,
    SvgBgPotnetComponent,
    ANPEnChiffresComponent,
    ChantiersInfrastructuresComponent,
    HistoriqueComponent,
    OrganisationComponent,
    PortMarocComponent,
    StatistiquesComponent,
    StatistiquesNationalComponent,
    CommuniquesPresseComponent,
    PortComponent,
    FilterPipe,
    SafeHtmlPipe,
    RapportsAnnuelsComponent,
    MvmNaviresComponent,
    MvmNaviresAutoriseeComponent,
    PortDetailComponent,
    FilterTabSearch,
    PortcontentComponent,
    SmartGateComponent,
    SecuritePortuaireComponent,
    PortnetComponent,
    PortnetServicesComponent,
    TarifsPublicsPlafondsComponent,
    IFPComponent,
    OffreDeFormationComponent,
    SimulateurComponent,
    ActualitesComponent,
    AgenceSectionComponent,
    AgencePageComponent,
    StatiqueMenuComponent,
    AppelsOffresComponent,
    PhotothequeComponent,
    VideothequeComponent,
    OffresEmploisComponent,
    EmploiFilterPipe,
    Home2Component,
    ContactComponent,
    LexiqueComponent,
    PlanSiteComponent,
    FilterAlphabetPipe,
    NewsletterComponent,
    FilterAnneePipe,
    PostulerComponent,FilterTabRegionPipe, Page404Component, RechercheComponent, ArchiveComponent
, GestionAccessComponent, SearchConfigComponent, CentreMediaComponent, BreadcrumbComponent, ConsignationPortsComponent, StatistiquesNationalComponent, MvmNaviresAutoriseeComponent, AppelConcurrenceComponent, ProgrammePrevComponent, AppelConsurrence2Component, SocietesautoriseesComponent, AppelManifestationComponent, DeposerCandidatureComponent
  ],
  imports: [
    MatSortModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatProgressBarModule,
    FormsModule,
    MatExpansionModule,
    MatStepperModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ReactiveFormsModule ,
    MatNativeDateModule,
    MatInputModule,
   
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    HighchartsChartModule,
    OrgchartModule
  ],
  providers: [
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: LoaderInterceptor, 
      multi: true }, 
    HomeService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
